import { PRICING_PLANS_APP_DEF_ID } from '@wix/pricing-plans-common/constants';

export const openBillingPage = (metaSiteId: string) => {
  window.open(
    `https://www.wix.com/store/plans?v=1&appDefId=${PRICING_PLANS_APP_DEF_ID}&siteGuid=${metaSiteId}&referralAdditionalInfo=PricingPlans`,
    '_blank',
  );
};
